import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import "./challengeDetails.style.scss"
import Navbar from '../navbar/navbar.comp.jsx';
import Event from '../event/event.comp.jsx';
import { UserContext } from '../../contexts/user.context.jsx';
import {
    getUserDoc,
    uploadAcceptedChallenge,
    countChallengesForChannel,
    getChallengeById
} from '../../utils/firebase/firebase.utils.js';
import SmallButton from '../smallButton/smallButton.comp.jsx';
import Button from '../button/button.comp.jsx';


const ChallengeDetails = () => {

    //INPUTS
    const { userID, currentUser } = useContext(UserContext)
    const navigate = useNavigate();
    const { linkID } = useParams();


    //[1] GET CHALLENGE 
    const [challenge, setChallenge] = useState(false);
    const [challengeLoadedBoolean, setChallengeLoadedBoolean] = useState(false);
    const [displayChallenge, setDisplayChallenge] = useState(true);
    const fetchChallenge = async () => {
        if (linkID) {
            const challenge = await getChallengeById(linkID);

            if (challenge.publicFlag === false && challenge.userID !== userID) {
                setDisplayChallenge(false)
            }

            if (challenge.publicFlag === false && challenge.userID === userID) {
                setDisplayChallenge(true)
            }

            setChallenge(challenge);
            setChallengeLoadedBoolean(true);

        } else {
            navigate('/'); // Redirect to home if no challenge is selected
        }
    }
    useEffect(() => {
        const timer = setTimeout(async () => {

            fetchChallenge()
        }, 200);

        return () => clearTimeout(timer);
    }, []);


    //[1] GET INFLUENCER
    const [channelLoaded, setChannelLoaded] = useState(false);
    const [userLoaded, setUserLoaded] = useState(false);
    const [userDoc, setUserDoc] = useState('');
    useEffect(() => {
        const timer = setTimeout(async () => {

            const userDoc = await getUserDoc(userID);
            setUserDoc(userDoc)

            setUserLoaded(true)
            setChannelLoaded(false)

        }, 200);

        return () => clearTimeout(timer);
    }, [challenge]);


    // [1] GET CHALLENGE COUNT
    const [challengesCount, setChallengesCount] = useState(0)
    const [challengesCountLoaded, setChallengesCountLoaded] = useState(false)
    useEffect(() => {

        const fetchChallengesCount = async () => {
            try {
                if (userLoaded) {
                    const totalChallenges = await countChallengesForChannel(challenge.userID);
                    setChallengesCount(totalChallenges);
                    setChallengesCountLoaded(true)
                }
            } catch (error) {
                console.error('Error fetching challenges count:', error);
            }
        };

        fetchChallengesCount();

    }, [userLoaded]);


    //[2] DISPLAY INFO
    const [displayInfo, setDisplayInfo] = useState(false);
    const toggleDisplay = () => {
        setDisplayInfo(!displayInfo)
    };


    // [2] ACCEPTING CHALLENGE (Button: Add to Schedule)
    const [acceptingChallenge, setAcceptingChallenge] = useState();
    useEffect(() => {
        setAcceptingChallenge(challenge)
    }, [challenge])
    const [events, setEvents] = useState([])
    useEffect(() => {
        setEvents(challenge.events)
    }, [challenge])


    // [2] ACCEPTING CHALLENGE (Button: Start)
    const [startClicked, setStartClicked] = useState(false)
    const [transitionState, setTransitionState] = useState('visible');
    const toggleStart = () => {
        setTransitionState('hidden');
        setTimeout(() => {
            setStartClicked(!startClicked);
            setTransitionState('visible');
        }, 300); // Match this to the CSS transition duration
    };
    const handleAddToSchedule = () => {
        toggleStart();
        handleToday();
    };


    // [2] ACCEPTING CHALLENGE (Buttons: Today, Tomorrow, NextWeek)
    const [todayClicked, setTodayClicked] = useState(false)
    const [tomorrowClicked, setTomorrowClicked] = useState(false)
    const [nextWeekClicked, setNextWeekClicked] = useState(false)
    const today = new Date();
    const handleToday = () => {

        const newArray = [...events];

        for (let i = 0; i < newArray.length; i += 5) {
            const eventNumber = newArray[i];
            const weekNumber = newArray[i + 1];
            const eventOfWeekNumber = newArray[i + 2];
            const daysToAdd = (weekNumber - 1) * 7 + (eventOfWeekNumber - 1);
            const date = new Date(today);
            date.setDate(today.getDate() + daysToAdd);

            // Format the date as "YYYY-MM-DD"
            const formattedDate = date.toISOString().split('T')[0];

            // Update the date in the array
            newArray[i + 3] = formattedDate;
        }

        setEvents(newArray);
        acceptingChallenge.events = newArray;
        // console.log(newArray);

        setTodayClicked(true)
        setTomorrowClicked(false)
        setNextWeekClicked(false)
    };
    const handleTomorrow = () => {
        const today = new Date();

        const newArray = [...events];

        for (let i = 0; i < newArray.length; i += 5) {
            const eventNumber = newArray[i];
            const weekNumber = newArray[i + 1];
            const eventOfWeekNumber = newArray[i + 2];
            const daysToAdd = (weekNumber - 1) * 7 + (eventOfWeekNumber - 1);
            const date = new Date(today);
            date.setDate(today.getDate() + 1 + daysToAdd);

            // Format the date as "YYYY-MM-DD"
            const formattedDate = date.toISOString().split('T')[0];

            // Update the date in the array
            newArray[i + 3] = formattedDate;
        }

        setEvents(newArray);
        acceptingChallenge.events = newArray;
        // console.log(newArray);

        setTodayClicked(false)
        setTomorrowClicked(true)
        setNextWeekClicked(false)
    };
    const handleNextWeek = () => {
        const today = new Date();
        const dayOfWeek = today.getDay(); // Get the current day of the week (0 = Sunday, 6 = Saturday)
        const daysUntilNextMonday = dayOfWeek === 1 ? 7 : (8 - dayOfWeek) % 7; // Calculate the days until next Monday
        const nextMonday = new Date(today);
        nextMonday.setDate(today.getDate() + daysUntilNextMonday); // Get the date of next Monday

        const newArray = [...events];

        for (let i = 0; i < newArray.length; i += 5) {
            const eventNumber = newArray[i];
            const weekNumber = newArray[i + 1];
            const eventOfWeekNumber = newArray[i + 2];
            const daysToAdd = (weekNumber - 1) * 7 + (eventOfWeekNumber - 1);
            const date = new Date(nextMonday);
            date.setDate(nextMonday.getDate() + daysToAdd);

            // Format the date as "YYYY-MM-DD"
            const formattedDate = date.toISOString().split('T')[0];

            // Update the date in the array
            newArray[i + 3] = formattedDate;
        }

        setEvents(newArray);
        acceptingChallenge.events = newArray;
        console.log(newArray);

        setTodayClicked(false)
        setTomorrowClicked(false)
        setNextWeekClicked(true)
    };


    // [2] ACCEPTING CHALLENGE (Dates)
    const formatDate = (date) => {
        // const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const options = { month: 'short', day: 'numeric' };
        return new Date(date).toLocaleDateString(undefined, options);
    };
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const getDayOfWeek = (date) => {
        return days[new Date(date).getDay()];
    };
    const daysLongVersion = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const getDayOfWeekLongVersion = (date) => {
        return daysLongVersion[new Date(date).getDay()];
    };

    //Clicking Day Buttons
    const dayClick = (x, eventNumber, eventDate, dayOfWeek) => {
        // console.log("Event Number:", eventNumber, "Event Date:", eventDate);
        // console.log("Day of Week: ", dayOfWeek);

        // Step 1: Find the day of event based on the eventDate
        const dayOfEvent = new Date(eventDate).toLocaleString('en-US', { weekday: 'long' });
        // console.log("Day of Event:", dayOfEvent);

        // Define the days of the week array
        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        // Step 2: Find the index of the day based on the eventDate
        const IndexOfDate = days.indexOf(dayOfEvent);
        // console.log("Index of Date:", IndexOfDate);

        // Step 3: Find the difference of the IndexOfDate and the provided x
        const difference = IndexOfDate - x;
        // console.log("Difference:", difference, "x: ", x);

        // Step 4: Calculate the new date based on the difference
        const newDate = new Date(eventDate);
        newDate.setDate(newDate.getDate() - difference);
        // console.log("New Date:", newDate.toISOString().split('T')[0]);

        // Step 5: Update the date in the events
        const updatedArray = [...events];

        // Find the index in the array where the date should be updated
        // The format of events is (event number, week number, event of week number, date, false)
        const eventIndex = updatedArray.findIndex((_, i) =>
            i % 5 === 0 && updatedArray[i] === eventNumber
        );

        if (eventIndex !== -1) {
            // Update the date in the array (index + 3 is the position of date)
            updatedArray[eventIndex + 3] = newDate.toISOString().split('T')[0];
        }

        setEvents(updatedArray);
        acceptingChallenge.events = updatedArray;
        // console.log("Updated Array:", updatedArray);

        setTodayClicked(false)
        setTomorrowClicked(false)
        setNextWeekClicked(false)
    };


    // [2] ACCEPTING CHALLENGE (Sign In Prompt)
    const handleSignInPrompt = () => {
        alert("To start a challenge, please create an account and sign in.");
    }


    //[3] POST: ACCEPTING CHALLENGE TO FIREBASE
    const [transitionWindow, setTransitionWindow] = useState(false)
    const toggleTransitionWindow = () => {
        setTransitionWindow(!transitionWindow)
        setLoading(false);
        setLoaded(false);
    }
    const [acceptedChallenge, setAcceptedChallenge] = useState();
    const generateUniqueID = (a, b, c) => {

        const a1 = a.toString().slice(0, 6);
        const b1 = b.toString().slice(0, 6);

        const year = c.getFullYear();
        const month = ("0" + (c.getMonth() + 1)).slice(-2); // Month is zero-based, so we add 1 and pad with leading zero if needed
        const day = ("0" + c.getDate()).slice(-2); // Pad day with leading zero if needed
        const hours = ("0" + c.getHours()).slice(-2); // Pad hours with leading zero if needed
        const minutes = ("0" + c.getMinutes()).slice(-2); // Pad minutes with leading zero if needed
        const seconds = ("0" + c.getSeconds()).slice(-2); // Pad seconds with leading zero if needed

        const formattedDate = `${year}${month}${day}${hours}${minutes}${seconds}`;

        const c1 = formattedDate;

        return `${c1}${a1}${b1}`;
    };
    const createAcceptedChallengeObject = () => {

        const acceptedID = generateUniqueID(userID, challenge.id, today);

        const firstDay = acceptingChallenge.events[3];
        const lastDay = acceptingChallenge.events[acceptingChallenge.events.length - 2]
        const totalEvents = acceptingChallenge.events.length / 5;

        setAcceptedChallenge({
            challengeID: challenge.id,
            userID: userID,
            acceptedID: acceptedID,
            channelID: challenge.channelID,
            // createdAt: will Auto Generate
            title: challenge.title,
            subtitle: challenge.subtitle,
            imageURL: challenge.imageURL,
            videoURL: challenge.videoURL,
            about: challenge.about,
            eventTitle: challenge.eventTitle,
            events: challenge.events,
            eventTime: challenge.eventTime,
            eventsTotal: challenge.eventsTotal,
            weeks: challenge.weeks,
            firstDay: firstDay,
            lastDay: lastDay,
            doneBoolean: false
        })
    }
    const handleStartChallenge = () => {
        toggleTransitionWindow();
        createAcceptedChallengeObject();
    }
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const handleSaveAndContinue = async (challengeObject, ID) => {
        setLoading(true); // Set loading to true when the process starts
        try {
            await uploadAcceptedChallenge(challengeObject, ID);
            // console.log('Accepted Challenge uploaded successfully!');
            // logEvent(analytics, 'challenge_accepted', { user_id: userID, challenge_id: challenge.id });
            // console.log('challenge_accepted', { user_id: userID, challenge_id: challenge.id });
        } catch (error) {
            console.error('Error uploading accepted challenge:', error);
        } finally {
            setLoading(false); // Set loading to false when the process ends
            setLoaded(true);
        }
        // console.log(acceptedChallenge)
    }


    //[3] ACCEPTING CHALLENGE TO FIREBASE (Navigate to CurrentChallenges)
    const handleCurrentChallenges = () => {
        navigate('/currentchallenges')
    }


    //[3] SHARING CHALLENGE
    const [shareLinkCopied, setShareLinkCopied] = useState(false)
    const handleCopyShareLink = () => {

        const shareLink = `${window.location.origin}/challenge/${challenge.id}`;

        navigator.clipboard.writeText(shareLink).then(() => {
            // console.log("Share link copied to clipboard: ", shareLink);
            setShareLinkCopied(true);
        }).catch(err => {
            console.error("Failed to copy share link: ", err);
        });
    }
    const [sharePopUp, setSharePopUp] = useState(false)
    const handleShare = () => {
        setSharePopUp(!sharePopUp)
        setShareLinkCopied(false)
    }


    //[3] VIDEO CLICKED
    const handleVideoClick = () => {
        if (challenge.videoURL) {
            window.open(challenge.videoURL, '_blank'); // Open video URL in a new tab
        } else {
            // console.log('No video URL available');
        }
    }


    // [3] GO TO INFLUENCER PAGE
    const handleProfileClick = () => {
        navigate(`/page/${userDoc.id}`);
    };


    return (
        <div>
            <Navbar />

            {/* Space */}
            <div style={{ height: '40px' }}>
            </div>

            {/* Loading Circle */}
            {!challengeLoadedBoolean && (
                // !challengeLoadedBoolean || !channelLoaded ? (
                <div className="loading-circle"></div>
            )}

            {/* Challenge Header & User Info */}
            {displayChallenge && challengeLoadedBoolean && (
                <div className="frame">
                    <div className="challenge columns">
                        <div className="image"
                            style={{
                                backgroundImage: `url(${challenge.imageURL})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}
                        />
                        <div className="challenge-info">
                            <div className="title">
                                <h2>{challenge.title}</h2>
                            </div>
                            <div className="text"
                                style={{
                                    cursor: 'pointer'
                                }}
                                onClick={toggleDisplay}
                            >
                                <div className="bold-info">
                                    <p style={{
                                        fontWeight: "bold",
                                        width: "fit-content"
                                    }}>
                                        {challenge.subtitle}
                                    </p>
                                    {challenge.videoURL && (
                                        <p className="link"
                                            onClick={handleVideoClick}
                                        >video</p>
                                    )}
                                </div>
                                <div className='description-text' style={{ width: "fit-content" }} onClick={toggleDisplay}>
                                    {challenge.about.split('\n\n').map((paragraph, index) => (
                                        <p key={index} style={{ marginBottom: '12px', textAlign: 'left' }}>
                                            {paragraph}
                                        </p>
                                    ))}
                                </div>
                            </div>

                            <div className="subtitle">
                                {!channelLoaded && !userLoaded ? (
                                    <div className="loading-circle"></div>
                                ) : userLoaded && (
                                    < div className="influencer">
                                        <div style={{
                                            backgroundImage: `url(${userDoc.imageURL})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            height: '44px',
                                            width: '44px',
                                            borderRadius: '50%',
                                            cursor: 'pointer'
                                        }}
                                            onClick={handleProfileClick}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.filter = 'grayscale(20%) brightness(120%)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.filter = 'none';
                                            }}
                                        >
                                        </div>
                                        <div className="inf-info">
                                            <p className="inf-title"
                                                onClick={handleProfileClick}
                                            >
                                                {userDoc.displayName}
                                            </p>
                                            {challengesCountLoaded && (
                                                <p className="inf-info">{challengesCount} challenge{challengesCount > 1 && 's'}</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Share Button */}
                                {userLoaded && (
                                    <Button
                                        text={'share'}
                                        option={'blue-inverted'}
                                        onClick={handleShare}
                                    />
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Start Buttons */}
            {displayChallenge && challengeLoadedBoolean && userLoaded && (
                <div className="frame">
                    {startClicked === false ? (
                        <div className='start-wrapper'>
                            <div className='start-button-title'>
                            </div>
                            <div className={`start-buttons ${transitionState}`}>
                                {/* <div className="start-button" onClick={handleAddToSchedule}>
                                            <p>Add to Schedule</p>
                                        </div> */}
                                <Button text={'Add to Schedule'} option={'green'} onClick={handleAddToSchedule} />
                            </div>
                        </div>
                    ) : (
                        <div className='start-wrapper'>
                            <div className='start-button-title'>
                            </div>
                            <div className={`start-buttons ${transitionState}`}>
                                {/* <div className="start-button" onClick={toggleStart}>
                                            <p>Cancel</p>
                                        </div> */}
                                <Button text={'Cancel'} option={'button-linked-text'} onClick={toggleStart} />
                                {userID && (
                                    <Button text={'Start Challenge'} option={'green'} onClick={currentUser ? handleStartChallenge : handleSignInPrompt} />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Week 1 */}
            {startClicked === true && (
                <div className="section frame events-wrapper">
                    <div className="events-title">
                        <h4 style={{ textAlign: "left" }}>Week 1</h4>
                        <div className='events-buttons'>
                            {
                                todayClicked ? (
                                    <SmallButton text={'Today'} option={'grey'} clicked={true} />
                                ) : (
                                    <SmallButton text={'Today'} option={'grey'} clicked={false} onClick={handleToday} />
                                )
                            }
                            {
                                tomorrowClicked ? (
                                    <SmallButton text={'Tomorrow'} option={'grey'} clicked={true} />
                                ) : (
                                    <SmallButton text={'Tomorrow'} option={'grey'} clicked={false} onClick={handleTomorrow} />
                                )
                            }
                            {
                                nextWeekClicked ? (
                                    <SmallButton text={'Next Week'} option={'grey'} clicked={true} />
                                ) : (
                                    <SmallButton text={'Next Week'} option={'grey'} clicked={false} onClick={handleNextWeek} />
                                )
                            }
                        </div>
                    </div>
                    {events.map((row, index) => {
                        // Check if the current element is the second `1` and it is at the correct position for iteration
                        if (index % 5 === 1 && row === 1) {

                            const eventNumber = events[index - 1];
                            const date = events[index + 2];

                            // Fetch event and time from the challenge (assuming challenge is available in the context)
                            const eventTitle = challenge.eventTitle;
                            const eventTime = challenge.eventTime;

                            //Dating
                            const dayOfWeek = getDayOfWeek(date);
                            const IndexOfDay = days.indexOf(dayOfWeek);

                            return (
                                <Event
                                    key={eventNumber}
                                    eventTime={eventTime}
                                    eventTitle={eventTitle}
                                    date={date}
                                    dayOfWeek={dayOfWeek}
                                    dateString={formatDate(date)}
                                    IndexOfDay={IndexOfDay}
                                    eventNumber={eventNumber}
                                    dayClick={dayClick}
                                />
                            );
                        }
                    })}
                </div>
            )}

            {/* Week 2 */}
            {startClicked === true && (challenge.weeks == 2 || challenge.weeks == 3) && (
                <div className="section frame events-wrapper">
                    <div className="events-title">
                        <h4 style={{ textAlign: "left" }}>Week 2</h4>
                    </div>
                    {events.map((row, index) => {
                        // Check if the current element is the second `1` and it is at the correct position for iteration
                        if (index % 5 === 1 && row === 2) {

                            const eventNumber = events[index - 1];
                            const date = events[index + 2];

                            // Fetch event and time from the challenge (assuming challenge is available in the context)
                            const eventTitle = challenge.eventTitle;
                            const eventTime = challenge.eventTime;

                            //Dating
                            const dayOfWeek = getDayOfWeek(date);
                            const IndexOfDay = days.indexOf(dayOfWeek);

                            return (
                                <Event
                                    key={eventNumber}
                                    eventTime={eventTime}
                                    eventTitle={eventTitle}
                                    date={date}
                                    dayOfWeek={dayOfWeek}
                                    dateString={formatDate(date)}
                                    IndexOfDay={IndexOfDay}
                                    eventNumber={eventNumber}
                                    dayClick={dayClick}
                                />
                            );
                        }
                    })}
                </div>
            )}

            {/* Week 3 */}
            {startClicked === true && challenge.weeks == 3 && (
                <div className="section frame events-wrapper">
                    <div className="events-title">
                        <h4 style={{ textAlign: "left" }}>Week 3</h4>
                    </div>
                    {events.map((row, index) => {
                        // Check if the current element is the second `1` and it is at the correct position for iteration
                        if (index % 5 === 1 && row === 3) {

                            const eventNumber = events[index - 1];
                            const date = events[index + 2];

                            // Fetch event and time from the challenge (assuming challenge is available in the context)
                            const eventTitle = challenge.eventTitle;
                            const eventTime = challenge.eventTime;

                            //Dating
                            const dayOfWeek = getDayOfWeek(date);
                            const IndexOfDay = days.indexOf(dayOfWeek);

                            return (
                                <Event
                                    key={eventNumber}
                                    eventTime={eventTime}
                                    eventTitle={eventTitle}
                                    date={date}
                                    dayOfWeek={dayOfWeek}
                                    dateString={formatDate(date)}
                                    IndexOfDay={IndexOfDay}
                                    eventNumber={eventNumber}
                                    dayClick={dayClick}
                                />
                            );
                        }
                    })}
                </div>
            )}

            {/* Pop Up Challenge Info */}
            {displayInfo === true && (
                <div className="inf-pop-up-container">
                    <div className="inf-pop-up">
                        <div className="inf-pop-up-header">
                            <div className="title">
                                <h2>About</h2>
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={toggleDisplay}>
                                </div>
                            </div>
                        </div>
                        <div className="inf-pop-up-scroll-view">
                            <div className="info">
                                <p style={{ fontWeight: "bold", width: "fit-content", marginBottom: "8px" }}>{challenge.info}</p>
                                {challenge.about.split('\n\n').map((paragraph, index) => (
                                    <React.Fragment key={index}>
                                        <p style={{ marginBottom: '12px', textAlign: 'left' }}>{paragraph}</p>
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Private Challenge */}
            {!displayChallenge && challengeLoadedBoolean && (
                <div>
                    <p>This is a private challenge, visible only to the user who created it.</p>
                    <Button text={'Refresh'} option={'button-linked-text'} onClick={fetchChallenge} />
                </div>
            )}

            <div style={{ height: '160px' }}></div>

            {/* Pop Up AcceptingChallengeWindow */}
            {transitionWindow === true && (
                <div className="accepting-challenge-pop-up-container">
                    <div className="accepting-challenge-pop-up">
                        {loading ? (
                            <div>
                                <div className="accepting-challenge-pop-up-header">
                                </div>
                                <div className="accepting-challenge-pop-up-scroll-view">
                                    {loading && <div className="loading-circle"></div>}
                                </div>
                            </div>
                        ) : (
                            loaded ? (
                                <div>
                                    <div className="accepting-challenge-pop-up-header">
                                        <div className="title">
                                            <h2>Done!</h2>
                                            <div
                                                className="close pointer"
                                                style={{
                                                    backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                                onClick={toggleTransitionWindow}>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accepting-challenge-pop-up-scroll-view">
                                        <div className="info">
                                            {/* <p style={{ fontWeight: "bold", width: "fit-content", marginBottom: "8px" }}>{challenge.info}</p> */}
                                            <p style={{ textAlign: 'center' }}><strong>{challenge.title}</strong> is added to your current challenges.</p>
                                        </div>
                                        <div
                                            className="yellow-button"
                                            onClick={handleCurrentChallenges}
                                        >
                                            <p>Go to current challenges</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="accepting-challenge-pop-up-header">
                                        <div className="title">
                                            {/* <h2>Add to schedule!</h2> */}
                                            <div
                                                className="close pointer"
                                                style={{
                                                    backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                                onClick={toggleTransitionWindow}>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accepting-challenge-pop-up-scroll-view">
                                        <div className="info">
                                            {/* <p style={{ fontWeight: "bold", width: "fit-content", marginBottom: "8px" }}>{challenge.info}</p> */}
                                            <p style={{ textAlign: 'center' }}>Adding <strong>{challenge.title}</strong> to your schedule starting <strong>{getDayOfWeekLongVersion(acceptingChallenge.events[3])}</strong> {formatDate(acceptingChallenge.events[3])}</p>
                                        </div>
                                        <div
                                            className="good-button"
                                            onClick={() => handleSaveAndContinue(acceptedChallenge, acceptedChallenge.acceptedID)}
                                        >
                                            <p>Add Challenge</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}

            {/* Pop Up Share */}
            {sharePopUp === true && (
                <div className="share-pop-up-container">
                    <div className="share-pop-up">
                        <div className="share-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleShare}
                                >
                                </div>
                            </div>
                            <div
                                style={{
                                    backgroundImage: `url(${challenge.imageURL})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    height: '200px',
                                    width: '200px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    borderRadius: '20px'
                                }}
                            >
                            </div>
                            <h3>{challenge.title}</h3>
                            {shareLinkCopied ? (
                                <div>
                                    <Button text={'Copied to clipboard!'} option={'blue-inverted-no-hover'} />
                                    <p style={{ fontSize: 'small', textAlign: 'center', margin: '0' }}>You can share this link with others!</p>
                                </div>
                            ) : (
                                <Button text={'Copy share link'} option={'green'} onClick={handleCopyShareLink} />
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div className="footer-margin">
            </div>
        </div >
    );
};

export default ChallengeDetails;